export const LOCATION_CHANGE = 'LOCATION_CHANGE';
export const APP_LOAD = 'APP_LOAD';
export const NAVIGATE = 'NAVIGATE';
export const FEATURE_STATE_LINKS = 'FEATURE_STATE_LINKS';
export const FEATURE_STATE_LINK = 'FEATURE_STATE_LINK';
export const FEATURE_STATE_RULE = 'FEATURE_STATE_RULE';
export const FEATURE_STATE_RULES_RESET = 'FEATURE_STATE_RULES_RESET';
export const SET_STORE = 'SET_STORE';
export const SESSION_FLUSH = 'SESSION_FLUSH';
export const UPDATE_SESSION_TIMESTAMP = 'UPDATE_SESSION_TIMESTAMP';
